export default {
  // 默认语言信息
  defalutLanguage: 'en',
  // 域名与语言对应关系
  domainMapLanguage: {
    '127.0.0.1': 'en'
  },
  // pc端浏览器最小宽度，小于等于该宽度将切换到移动版本. 设置大于100的值
  toMobileWidth: 992,
  // 移动端设计稿px（高），1rem = 10px
  designPx: 375,
  // 重定向中间件配置
  redirect: {
    // 设置不重定向的路径, 用的是includes的规则，添加配置的时候，注意不要影响现有功能
    excludes: ['/front-api']
  },
  // 所有站点信息
  siteList: [
    {
      siteCode: 'EN',
      siteId: 1,
      tstAtCode: '627869',
      prodAtCode: '628978'
    },
    {
      siteCode: 'UK',
      siteId: 2,
      tstAtCode: '629553',
      prodAtCode: '629549'
    },
    {
      siteCode: 'MENA',
      tstAtCode: '629551',
      prodAtCode: '629552',
      siteId: 3
    },
    {
      siteCode: 'ZA',
      siteId: 4,
      tstAtCode: '629842',
      prodAtCode: '629843'
    },
    {
      siteCode: 'ES',
      siteId: 5,
      tstAtCode: '630873',
      prodAtCode: '630874'
    },
    {
      siteCode: 'VN',
      siteId: 6,
      tstAtCode: '630871',
      prodAtCode: '630872'
    },
    {
      siteCode: 'FR',
      siteId: 7,
      tstAtCode: '631561',
      prodAtCode: '631562'
    },
    {
      siteCode: 'CATC',
      siteId: 8,
      tstAtCode: '631559',
      prodAtCode: '631560'
    },
    {
      siteCode: 'TR',
      siteId: 9,
      tstAtCode: '631565',
      prodAtCode: '631556'
    },
    {
      siteCode: 'ID',
      siteId: 10,
      tstAtCode: '631560',
      prodAtCode: '631564'
    },
    {
      siteCode: 'BR',
      siteId: 11,
      tstAtCode: '631557',
      prodAtCode: '631558'
    },
    {
      siteCode: 'PT',
      siteId: 12,
      tstAtCode: '631693',
      prodAtCode: '631692'
    },
    {
      siteCode: 'KR',
      siteId: 13,
      tstAtCode: '631695',
      prodAtCode: '631694'
    },
    {
      siteCode: 'AMERICAS',
      siteId: 14,
      tstAtCode: '631699',
      prodAtCode: '631698'
    },
    {
      siteCode: 'TH',
      siteId: 15,
      tstAtCode: '631701',
      prodAtCode: '631700'
    },
    {
      siteCode: 'AU',
      siteId: 16,
      tstAtCode: '631830',
      prodAtCode: '631829'
    },
    {
      siteCode: 'AR',
      siteId: 17,
      tstAtCode: '631697',
      prodAtCode: '631696'
    },
    {
      siteCode: 'AF-FR',
      siteId: 18,
      tstAtCode: '633037',
      prodAtCode: '633036'
    },
    {
      siteCode: 'EU',
      siteId: 21,
      tstAtCode: '637456',
      prodAtCode: '637454'
    },
    {
      siteCode: 'LK',
      siteId: 26,
      tstAtCode: '638375',
      prodAtCode: '638376'
    },
    {
      siteCode: 'ASIA',
      siteId: 27,
      tstAtCode: '642367',
      prodAtCode: '642368'
    }
  ],
  // 微影站点信息
  microtechSiteList: [
    {
      siteCode: 'EN',
      siteId: 19,
      tstAtCode: '627869',
      prodAtCode: '628978'
    }
  ],
  defaultSitePrefix: 'en'
}
